<template>
  <Header>
    <Menu mode="horizontal" theme="dark" active-name="1">
      <div class="layout-logo">管理平台</div>
      <div class="layout-nav">
        <MenuItem name="1" :to="{path: '/'}">
          <Icon type="ios-navigate"></Icon>
          站点首页
        </MenuItem>
        <!-- <MenuItem name="2">
          <Icon type="ios-keypad"></Icon>
          系统情况
        </MenuItem> -->
        <MenuItem name="3">
          <a @click="adminLogout" style="color:#ffffff;">
          <Icon type="ios-analytics"></Icon>
          退出登录
          </a>
        </MenuItem>
      </div>
    </Menu>
  </Header>
</template>
<script>
export default {
  methods: {
    //用户退出
    adminLogout() {
      localStorage.removeItem("adminInfo")
      window.location.reload()
    },
  }
}
</script>